import React from "react";
import { FolioSearch } from "../app-template/AppContent";
import IntroSection from "./intro";
import ResearchSection from "./research";
import IdeationSection from "./ideation";
import WireframingSection from "./wireframing";
import DesignBuildSection from "./designBuild";
import ValidationSection from "./testingValidation";
import RetroSection from "./retrospective";
import SideNav from "./sideNav";
import CruiseHeaderImg from "../img/cs-iglu-search/cruise-med-large2.jpg";

function IgluSearchCS() {
	return (
		<section className="case-study-template iglu-search" id="iglu-search">
			<div className="header">
				<figure className="hero-image">
					<img
						src={CruiseHeaderImg}
						alt="Cruise ship in Mediterranean with sunset"
					/>
				</figure>
				<div className="header-title-block">
					<span className="inner">
						<span className="case-study-tags">
							{FolioSearch.tag01 + " // " + FolioSearch.tag02}{" "}
						</span>
						<h2 className="case-study-title"> {FolioSearch.caseStudy}</h2>
					</span>
				</div>
			</div>
			<div className="container">
				<SideNav />
				<article className="content">
					<IntroSection />
					<ResearchSection />
					<IdeationSection />
					<WireframingSection />
					<DesignBuildSection />
					<ValidationSection />
					<RetroSection />
				</article>
			</div>
		</section>
	);
}

export default IgluSearchCS;
